<template>
    <div class="h-screen w-screen fixed top-0" style="z-index: 50;">
        <div @click="closePopup" class="w-full h-full fixed top-0 left-0 bg-grey-800 opacity-50"></div>

        <div class="fixed bottom-0 w-full md:w-3/4 lg:w-1/2 lg:rounded-tl-lg lg:rounded-tr-lg h-auto max-h-full bg-green-90 overflow-y-auto" style="left: 50%; transform: translate(-50%, 0);">
            <div class="flex flex-col max-h-screen overflow-hidden">
				<div class="flex -mb-3 pt-5 pb-3 px-5">
					<h1 class="flex-grow font-sans text-4xl sm:text-5xl m-0 -mt-2 text-green-1000">Recover password</h1>

					<a @click="closePopup" @keypress.enter="closePopup" tabindex="0" class="block relative -mt-2 px-5 cursor-pointer">
						<svg xmlns="http://www.w3.org/2000/svg" class="block absolute" style="top: 50%; left: 50%; transform: translate(-50%, -50%); width: 40px; height: 40px;" viewBox="0 0 31 31" fill="none">
							<path d="M23.25 7.75L7.75 23.25" stroke="#2F493C" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M7.75 7.75L23.25 23.25" stroke="#2F493C" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</a>
				</div>

                <div v-if="this.error" class="mt-2 mb-4 pt-5 pb-4 px-5 bg-red-600 text-white text-xl font-body">
					{{ this.error }}
				</div>

				<div v-if="success" class="pb-5 px-5">
					<p class="text-green-900 text-xl font-body leading-tight mt-2">If there's an account with a matching address, we've sent a link to reset your password, that's valid for 1 hour.</p>
				</div>
				<div v-else class="overflow-y-auto">
					<div class="px-5 pb-5">
						<input @keypress.enter="sendEmail" class="block w-full font-sans rounded-none bg-transparent text-green-800 placeholder-green-600 border-8 border-solid border-grey-500 px-2 py-2 text-2xl" type="text" placeholder="Enter your email address..." v-model="email" />
					</div>

					<a @click="sendEmail" @keypress.enter="sendEmail" tabindex="0" class="block w-full font-sans border-none bg-grey-700 text-green-300 text-3xl text-center leading-tight py-4 sm:py-8 no-underline cursor-pointer">
						SEND
					</a>
				</div>
			</div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
	data() {
        return {
			error: "",
			email: "",
			success: false
        }
    },
    methods: {
		closePopup() {
			this.success = false;
			this.$parent.showPasswordRecovery = false;
		},
        async sendEmail() {
            var that = this;
			this.error = "";
			axios.get('https://bakerstreet.arturs.co.uk/api/lostinthecity/recover/send?email=' + this.email)
			.then(function (response) {
				var data = response.data;

				if (data.success == true) {
					that.email = "";
					that.success = true;
				} else {
					that.error = data.response;
				}
			})
			.catch(function (error) {
				if (error.response) {
					var data = error.response.data;
					that.error = data.response;
				} else {
					that.error = "An error has occured";
				}
			});
        }
    }
}
</script>